import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { NeizhenUtil } from "@/util/datarouters";
import { tabsList, tHallPolicyFileSave, tHallPolicyFileUpdate } from "@/api/portrayal/policy";
import { getList } from "@/api/system/role";
import { sysFileUpload, sysFileDelete } from "@/api/managementCenter/otherApi";
import "@/util/jquery-2.2.4.min.js";
import quillEditorCom from "@/components/common/quillEditor.vue";
import treeMenu from "@/components/treeMenu/index.vue";
export default {
  name: "addFilePollicy",
  props: {
    addData: {
      type: Object,
      required: true
    }
  },
  components: {
    quillEditorCom: quillEditorCom,
    treeMenu: treeMenu
  },
  data: function data() {
    return {
      chooseDepartment: {
        state: false,
        data: {},
        showBox: false
      },
      subDisabled: false,
      show: false,
      type: "",
      data: null,
      filelist: [],
      formValidate: {
        title: "",
        fileType: "",
        type: "1",
        roleIds: [],
        fileIds: [],
        content: "",
        deptId: "",
        deptName: "",
        id: ""
      },
      // 表单数据绑定
      ruleValidate: {
        title: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        fileType: [{
          required: true,
          message: "请选择文件分类",
          trigger: "change"
        }],
        type: [{
          required: true,
          message: "请选择文件来源",
          trigger: "change"
        }],
        roleIds: [{
          required: true,
          message: "权限不能为空",
          trigger: "change"
        }],
        content: [{
          required: true,
          message: "内容不能为空",
          trigger: "blur"
        }],
        deptId: [{
          required: true,
          message: "请选择部门",
          trigger: "change"
        }],
        fileIds: [{
          required: true,
          message: "请上传文件",
          trigger: "change"
        }]
      },
      // 表单验证
      selectData: [],
      roleList: []
    };
  },
  computed: {},
  watch: {
    show: function show(value) {
      if (value) {
        this.getRoleList();
        this.showAddData();
      } else {
        this.filelist = [];
        this.formValidate = {
          title: "",
          fileType: "",
          type: "1",
          roleIds: [],
          fileIds: [],
          content: "",
          deptId: "",
          deptName: "",
          id: ""
        };
      }
    }
  },
  methods: {
    // 显示弹框
    dialogShow: function dialogShow(type, data) {
      // 重置表单、显示弹框
      this.show = true;
      this.type = type;
      this.data = data;

      if (type == "edit") {
        this.formValidate.title = data.title;
        this.formValidate.id = data.id;
        this.formValidate.content = data.content;
        this.formValidate.deptId = data.deptId;
        this.formValidate.deptName = data.deptName;
        this.formValidate.fileType = data.fileType;
        this.formValidate.roleIds = data.fileRole.map(function (item) {
          return Number(item.roleId);
        });
        this.filelist = (data.fileList || []).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            name: item.fileName,
            id: item.fileId
          });
        });
      }
    },
    beforeRemoveFn: function beforeRemoveFn(file) {
      var _this = this;

      if (!file.id) {
        return;
      }

      this.deleteFile(file.id, function () {
        _this.filelist = _this.filelist.filter(function (i) {
          return file.id != i.id;
        });
      });
    },
    deleteFile: function deleteFile(id, callback) {
      var _this2 = this;

      sysFileDelete(id).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          callback && callback();

          _this2.$message.success("删除成功!");
        } else {
          _this2.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function (err) {
        _this2.$message.error("删除异常!");
      });
    },
    // 上传文件之前的方法
    beforeUploadFn: function beforeUploadFn(file) {
      var _this3 = this;

      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }

      var fd = new FormData();
      fd.append("fromTarget", 0);
      fd.append("file", file); //上传到后台

      this.loading = true;
      sysFileUpload(fd).then(function (_ref2) {
        var data = _ref2.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("上传文件成功!");

          _this3.filelist.push(_objectSpread(_objectSpread({}, data.data), {}, {
            name: data.data.fileName
          }));
        } else {
          _this3.$message.warning(data.msg || "上传文件失败!");
        }
      }).catch(function (err) {
        _this3.loading = false;

        _this3.$message.error("上传文件异常!");
      });
    },
    // 更换部门名称弹框
    changeUserDept: function changeUserDept() {
      this.chooseDepartment.data = {};
      this.chooseDepartment.chooseBox = false;
      this.chooseDepartment.state = true;
    },
    nodeIdModal: function nodeIdModal(tree) {
      this.chooseDepartment.data = tree;
    },
    // 新增-部门选择确认按钮
    depTreeBtn: function depTreeBtn() {
      this.formValidate.deptId = this.chooseDepartment.data.id;
      this.formValidate.deptName = this.chooseDepartment.data.name;
      this.chooseDepartment.state = false;
    },
    getRoleList: function getRoleList() {
      var _this4 = this;

      getList().then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this4.roleList = data.data;
        } else {
          _this4.$message.error(data.msg);
        }
      });
    },
    showAddData: function showAddData() {
      var _this5 = this;

      var url = null;
      url = "/admin/dict/type/policy_type";
      tabsList(url).then(function (res) {
        if (res.data.code == 0) {
          _this5.selectData = res.data.data || [];
        }
      });
    },
    submitForm: function submitForm(formNames) {
      var _this6 = this;

      this.formValidate.fileIds = this.filelist.map(function (i) {
        return i.id;
      });
      this.$refs[formNames].validate(function (valid) {
        if (valid) {
          _this6.subDisabled = true;
          var obj = {
            fileType: String(_this6.formValidate.fileType),
            fileRole: _this6.formValidate.roleIds.map(function (item) {
              return {
                roleId: String(item)
              };
            }),
            title: _this6.formValidate.title,
            type: _this6.formValidate.type,
            content: _this6.formValidate.content,
            deptId: _this6.formValidate.deptId,
            fileIds: _this6.formValidate.fileIds
          };

          if (_this6.type == "edit") {
            obj.id = _this6.formValidate.id;
          }

          var method = tHallPolicyFileSave;

          if (_this6.type == "edit") {
            method = tHallPolicyFileUpdate;
          }

          method(obj).then(function (_ref4) {
            var data = _ref4.data;

            if (data.code == 0) {
              _this6.$message.success(_this6.type == "edit" ? "编辑成功" : "新增成功");

              _this6.$emit("callBack");

              _this6.show = false;
            } else {
              _this6.$message.error(data.msg);
            }
          }).finally(function () {
            _this6.subDisabled = false;
          });
        }
      });
    }
  }
};